import React, { useContext } from "react";
import { StoreContext } from "../context/StoreContext";
import iconSearch from "../images/icon-search.svg";
import iconAccount from "../images/icon-account.svg";
import iconCart from "../images/icon-cart.svg";
import { navigate } from "gatsby";

function HeaderIcons(props) {
  const { toggleSearchOpen, checkout } = useContext(StoreContext);

  const realLineItems =
    checkout &&
    checkout?.lineItems?.filter(
      item =>
        item.customAttributes[0]?.key !== "Bundle item" &&
        item.customAttributes[0]?.key !== "isBundleItem"
    ); // Remove bundle content from the count

  const qty = realLineItems?.reduce((total, item) => total + item.quantity, 0);

  const { additionalClasses } = props;

  return (
    <div className={`${additionalClasses} text-right header__icons`}>
      <button
        type="button"
        className="icon__button icon__button--search mr-2"
        onClick={toggleSearchOpen}
      >
        <img className="icon icon--search" src={iconSearch} alt="Search" />
      </button>
      <a
        href="/account"
        className="mr-2 account__link account__link--account d-none d-md-inline"
      >
        <img className="icon icon--account" src={iconAccount} alt="Account" />
      </a>
      <button
        type="button"
        className="icon__button icon__button--cart"
        onClick={() => {
          navigate("/cart");
        }}
      >
        <img className="icon icon--cart" src={iconCart} alt="Shopping bag" />
      </button>
      {qty && qty >= 0 ? (
        <div className="cart__qty text-right">
          <span className="cart__qty--text">{qty}</span>
        </div>
      ) : null}
    </div>
  );
}

export default HeaderIcons;
